// fe/src/components/tools/event-logistics/SavedPlans.js

import React, { useState, useEffect } from 'react';
import { Container, Card, Button, Row, Col, Table, Badge, Spinner, Breadcrumb } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faArrowLeft, faEye, faTrash, faClock, faUsers, faDownload } from '@fortawesome/free-solid-svg-icons';
import '../common.css';
import { downloadEventPlanById, getSavedEventPlans } from '../../../service/workflow-api';

const SavedPlans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadSavedPlans();
  }, []);

  const loadSavedPlans = async () => {
    try {
      setLoading(true);
      const response = await getSavedEventPlans();
      // if (!response.ok) {
      //   throw new Error('Failed to load saved plans');
      // }
      console.log("Fetched plans:", response);
      console.log("Response status:", response.status);
      setPlans([...response]);
      setLoading(false);
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (planId) => {
    if (window.confirm('Are you sure you want to delete this plan?')) {
      try {
        // Simulate deleting a plan
        setPlans(plans.filter(plan => plan.id !== planId));
      } catch (err) {
        setError('Failed to delete plan');
      }
    }
  };

  const downloadPlan = async (planId) => {
    try {
      const response = await downloadEventPlanById(planId);
      if (!response.ok) {
        throw new Error('Failed to download plan');
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `event_plan_${planId}.xlsx`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      setError(`Failed to download plan: ${error.message}`);
    }
  };

  return (
    <>
      <Breadcrumb className="dark-breadcrumb mb-4">
        <Breadcrumb.Item><Link to="/ai-workflows">AI Workflows</Link></Breadcrumb.Item>
        <Breadcrumb.Item><Link to="/ai-workflows/ai-logistics-staff-planning">Events Logistics and Staff Planner</Link></Breadcrumb.Item>
        <Breadcrumb.Item active>Saved Plans</Breadcrumb.Item>
      </Breadcrumb>

      <Container fluid className="py-4">
        <Card className="dark-main-card">
          <Card.Body className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2 className="mb-0 text-white" style={{ fontSize: "1.5rem" }}>Saved Plans</h2>
              {/* Add back button */}
            </div>

            {error && (
              <div className="alert dark-alert alert-danger mb-4">
                {error}
              </div>
            )}

            {loading ? (
              <div className="text-center">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : plans.length === 0 ? (
              <Card className="dark-card-alt text-center p-5">
                <Card.Text className="text-muted">
                  No saved plans found. Create a new plan to get started.
                </Card.Text>
              </Card>
            ) : (
              <div className="table-responsive">
                <Table className="table-dark">
                  <thead>
                    <tr>
                      <th>Event Name</th>
                      <th>Created</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {plans.map((plan) => (
                      <tr key={plan.id}>
                        <td className="text-white">{plan.form_data_json ? plan.form_data_json.eventName : "N/A"}</td>
                        <td>
                          <FontAwesomeIcon icon={faClock} className="me-1 text-muted" />
                          {new Date(plan.created_at).toLocaleDateString()}
                        </td>
                        <td>
                          <Button
                            variant="link"
                            className="text-primary me-2 p-0"
                            onClick={() => console.log('View plan')}
                          >
                            <FontAwesomeIcon icon={faEye} />
                          </Button>
                          <Button
                            variant="link"
                            className="text-danger p-0"
                            onClick={() => handleDelete(plan.id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </Button>
                          <Button
                            variant="link"
                            className="text-success p-0"
                            onClick={() => downloadPlan(plan.id)}
                          >
                            <FontAwesomeIcon icon={faDownload} />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default SavedPlans;